import "./main.scss";

import "./utils/utils.js";
import "./others/others.js";
import "./components/components.js";
import "./pages/pages.js";



if (module.hot) {
	module.hot.dispose(function (data) {
		// module is about to be replaced.
		// You can save data that should be accessible to the new asset in `data`
		// data.updated = Date.now();
		// console.log('dispose')
		// console.log('data',data)
	});

	module.hot.accept(function (getParents) {
		// module or one of its dependencies was just updated.
		// data stored in `dispose` is available in `module.hot.data`
		// let { updated } = module.hot.data;
		// console.log('getParents',getParents)
		// console.log('updated',updated)
	});
}
